export function authHeader () {
  // return authorization header with jwt token
  let response = JSON.parse(localStorage.getItem('tokens'))

  if (response && response.access_token) {
    return { 'Authorization': 'Bearer ' + response.access_token }
  } else {
    return {}
  }
}

export function tokenParse (accessToken) {
  // fake backend support
  if (accessToken === 'fake-jwt-token') {
    return {
      sub: 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
      exp: (Date.now() / 1000) + (30 * 24 * 60 * 60),
      role: 1
    }
  }

  const sec = accessToken.split('.')
  if (sec.length < 3) {
    return false
  }
  return JSON.parse(Buffer.from(sec[1], 'base64').toString('ascii'))
}

export function tokenValid (exp) {
  if (Date.now() >= exp * 1000) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js